module.exports = __webpack_public_path__ + "img/login.2fbae7c8.png";